import ActionType from 'actions/ActionType'
import timeUnitsInSeconds, { timeUnitFinder } from 'utils/timeUnitsInSeconds'
import taskTypeIDToNameMap from 'utils/taskTypeIDToNameMap'

export default (state = 0, action) => {
  switch (action.type) {
    case ActionType.Tasks.SET_DELAY:
      return action.payload ? parseInt(action.payload) : ''
    case ActionType.Tasks.RECEIVE_TASK:
      if (
        action.payload &&
        action.payload.task_type_id &&
        taskTypeIDToNameMap[action.payload.task_type_id]
      ) {
        // will be one of 'send_email', 'send_sms', etc.
        const payload_name =
          taskTypeIDToNameMap?.[action.payload.task_type_id]?.payload_name

        const delay_seconds = action.payload?.[payload_name]?.delay_seconds

        const unitInSeconds =
          timeUnitsInSeconds?.[timeUnitFinder(delay_seconds)]

        return delay_seconds / unitInSeconds
      }

      return 0
    default:
      return state
  }
}
